// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for all devices */
.manage-course-container {
  display: flex;
  flex-wrap: wrap;
}

.course-list,
.module-list,
.lesson-list {
  flex: 1 1 100%;
  padding: 10px;
  margin: 10px;
  background-color: #dceb7b;
  border-radius: 4px;
  max-height: 1000px;
  overflow-y: auto;
  max-width: 200px;
  min-width: 200px;
}

.course-item,
.module-item,
.lesson-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  margin-bottom: 5px;
  background-color: #f9fbfd;
  border-radius: 4px;
}

.course-name,
.module-name,
.lesson-name {
  flex: 1 1;
  padding: 5px;
}

.copy-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #666;
  transition: color 0.2s;
}

.copy-button:hover {
  color: #333;
}

.selected {
  background-color: #5e9fe4;
}

.additional-components {
  flex: 1 1 100%;
  padding: 10px;
  margin: 10px;
  background-color: #dceb7b;
  border-radius: 4px;
  max-height: 1000px;
  overflow-y: auto;
}

/* Responsive styles for larger screens (min-width: 768px) */
@media (min-width: 768px) {
  .manage-course-container {
    flex-wrap: nowrap;
  }

  .course-list,
  .module-list,
  .lesson-list,
  .additional-components {
    flex: 1 1 auto;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; */
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  min-width: 400px;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.modal-content h3 {
  margin-top: 0;
  color: #333;
  font-size: 1.2em;
}

.modal-content p {
  margin-bottom: 15px;
  color: #666;
}

.modal-select {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.confirm-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.confirm-button:hover {
  background-color: #45a049;
}

.cancel-button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.cancel-button:hover {
  background-color: #da190b;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/ManageCourse.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;;EAGE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;EAGE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;;EAEA;;;;IAIE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC;;;kBAGgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Base styles for all devices */\n.manage-course-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.course-list,\n.module-list,\n.lesson-list {\n  flex: 1 1 100%;\n  padding: 10px;\n  margin: 10px;\n  background-color: #dceb7b;\n  border-radius: 4px;\n  max-height: 1000px;\n  overflow-y: auto;\n  max-width: 200px;\n  min-width: 200px;\n}\n\n.course-item,\n.module-item,\n.lesson-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding: 5px;\n  margin-bottom: 5px;\n  background-color: #f9fbfd;\n  border-radius: 4px;\n}\n\n.course-name,\n.module-name,\n.lesson-name {\n  flex: 1;\n  padding: 5px;\n}\n\n.copy-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  color: #666;\n  transition: color 0.2s;\n}\n\n.copy-button:hover {\n  color: #333;\n}\n\n.selected {\n  background-color: #5e9fe4;\n}\n\n.additional-components {\n  flex: 1 1 100%;\n  padding: 10px;\n  margin: 10px;\n  background-color: #dceb7b;\n  border-radius: 4px;\n  max-height: 1000px;\n  overflow-y: auto;\n}\n\n/* Responsive styles for larger screens (min-width: 768px) */\n@media (min-width: 768px) {\n  .manage-course-container {\n    flex-wrap: nowrap;\n  }\n\n  .course-list,\n  .module-list,\n  .lesson-list,\n  .additional-components {\n    flex: 1 1 auto;\n  }\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  /* display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000; */\n}\n\n.modal-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  min-width: 400px;\n  max-width: 500px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.modal-content h3 {\n  margin-top: 0;\n  color: #333;\n  font-size: 1.2em;\n}\n\n.modal-content p {\n  margin-bottom: 15px;\n  color: #666;\n}\n\n.modal-select {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 15px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.confirm-button {\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.confirm-button:hover {\n  background-color: #45a049;\n}\n\n.cancel-button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cancel-button:hover {\n  background-color: #da190b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
